import styled, { css } from 'styled-components';
import dotsBg from '~/assets/images/shop/dots_bg.svg';
import dotsMask from '~/assets/images/shop/dots_mask.svg';
import newShadow from '~/assets/images/shop/new_shadow.png';
import { Text } from '../Text';

const StyledCategory = styled.div<{
	$active?: boolean;
	$bgColor?: string;
	$disabled?: boolean;
}>`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 11px;
	width: 120px;
	height: 120px;
	background: ${(props) => props.$bgColor || 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	cursor: pointer;
	transition: background-color 0.3s ease;
	overflow: hidden;

	img {
		top: 40px;
		width: 40px;
		height: 40px;
		object-fit: contain;
		user-select: none;
		pointer-events: none;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	${Text} {
		max-width: 100px;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	${(props) =>
		props.$disabled
			? css`
					background: rgba(255, 255, 255, 0.02);
					border: 1px solid rgba(255, 255, 255, 0.05);
					cursor: default;
					pointer-events: none;

					img {
						opacity: 0.25;
					}

					${Text} {
						color: rgba(255, 255, 255, 0.25);
					}
			  `
			: css`
					&:hover {
						background-color: #ffffff;

						img {
							filter: invert(100%);
						}

						${Text} {
							color: #000000;
						}
					}
			  `}

	${(props) =>
		props.$active &&
		css`
			background-color: #ffffff;

			img {
				filter: invert(100%);
			}

			${Text} {
				color: #000000;
			}
		`}

	${(props) =>
		props.$disabled &&
		css`
			background-color: rgba(255, 255, 255, 0.02);
			border: 1px solid rgba(255, 255, 255, 0.05);
			cursor: default;
			pointer-events: none;

			${Text} {
				color: rgba(255, 255, 255, 0.25);
			}

			img {
				opacity: 0.25;
			}
		`}
`;

const StyledNewDot = styled.div`
	position: absolute;
	top: 14px;
	right: 14px;
	z-index: 1;
	width: 10px;
	height: 10px;
	border-radius: 10px;
	background: #ff3232;
`;

const StyledNewShadow = styled.div`
	position: absolute;
	top: 8px;
	right: 4px;
	z-index: 0;
	width: 30px;
	height: 30px;
	background-image: url(${newShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledDotsBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 120px;
	height: 120px;
	mask-image: url(${dotsMask});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: contain;
	-webkit-mask-image: url(${dotsMask});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	background-image: url(${dotsBg});
	background-position: 0 0;
	background-size: auto auto;
	background-repeat: repeat;
`;

export { StyledCategory, StyledDotsBg, StyledNewDot, StyledNewShadow };
